import { useQuery } from '@tanstack/react-query';
import type { PaginatedExportsDto, ListExportsQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ExportsApiResponse {
  success: boolean;
  data: PaginatedExportsDto;
}

export function useExports(query?: Partial<ListExportsQuery>) {
  return useQuery({
    queryKey: queryKeys.exports.list(query),
    queryFn: async () => {
      const response = await apiClient.get<ExportsApiResponse>('/exports', { params: query });
      return response.data.data;
    },
  });
}
